import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Select from '../../../Part_Sample/Select';
import ipcam from '../../../../Images/Daikin_Images/image/Ipcam.png'
import nvr from '../../../../Images/Daikin_Images/image/NVR.png'

export default class DLinkCameras extends Component {
    constructor(props) {
        super(props);

        // Retrieve the list of dlink devices
        let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));

        // Tommy - 13/04/2021
        let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        this.controller_mac_addr = controller_info.mac_addr;
        this.controller_username = controller_info.username;

        if (dlinkcameras == null || dlinkcameras == undefined || dlinkcameras == []) {
            dlinkcameras = {};
            dlinkcameras[this.controller_mac_addr] = {};
            dlinkcameras[this.controller_mac_addr][this.controller_username] = { "cameras": [], "num_screen": 2 };
            window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
        } else if (dlinkcameras[this.controller_mac_addr] == null) {
            dlinkcameras[this.controller_mac_addr] = {};
            dlinkcameras[this.controller_mac_addr][this.controller_username] = { "cameras": [], "num_screen": 2 };
            window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
        }

        if (dlinkcameras[this.controller_mac_addr][this.controller_username] == null) {
            dlinkcameras[this.controller_mac_addr][this.controller_username] = { "cameras": [], "num_screen": 2 };
            window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
        }

        // Retrieving user's list of registered cameras 
        this.devices = [];
        if (dlinkcameras[this.controller_mac_addr][this.controller_username].cameras != null) {
            this.devices = dlinkcameras[this.controller_mac_addr][this.controller_username].cameras;
        }

        // User's preference for number of screens displayed
        let num_screen = 2;
        if (dlinkcameras[this.controller_mac_addr][this.controller_username] == null) {
            dlinkcameras[this.controller_mac_addr][this.controller_username].num_screen = 2;
            window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
        } else num_screen = dlinkcameras[this.controller_mac_addr][this.controller_username].num_screen;

        this.indexToAdd = 0;
        this.nvrUsername = '';
        this.nvrPassword = '';
        this.nvrSerialNo = '';

        let drop_down_list = [];
        drop_down_list.push(<option value={2} key={2}>{2}</option>);
        drop_down_list.push(<option value={3} key={3}>{3}</option>);
        drop_down_list.push(<option value={4} key={4}>{4}</option>);
        drop_down_list.push(<option value={6} key={6}>{6}</option>);
        drop_down_list.push(<option value={8} key={8}>{8}</option>);

        this.state = {
            showMenu: false,
            num_screen: num_screen,
            count: 0,
            drop_down_list: drop_down_list,
        }
    }

    //Handle change number of screens
    handleChangeNumScreen = (key) => {

        this.setState({
            num_screen: key
        });

        let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
        dlinkcameras[this.controller_mac_addr][this.controller_username].num_screen = key;
        window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
    }

    //Go to add device page
    handleAddDevice = () => {
        window.app.content_area.current.switch_content.current.handleShowBottomControls();
        this.props.content_handler('DLinkAddEditCamera', { from: 'DLinkAddCamera' });
    }

    //Go to previous screen
    handlePrevious = () => {
        window.app.content_area.current.switch_content.current.handleHideBottomMenu();
        this.props.content_handler('IPCam_Settings');
    }

    //Go to camera details view
    accessCameraDetailsView = (index) => {
        window.sessionStorage.setItem("DeviceDetail", index);
        window.app.content_area.current.switch_content.current.handleShowBottomControls();
        this.props.content_handler('DLinkAddEditCamera', { from: 'DLinkEditCamera', index: index });
    }

    render() {
        let main_content_style = {
            position: 'fixed',
            color: 'white',
            height: this.props.height,
            width: '100%',
            overflow: 'auto',
        }

        let container_style = {
            paddingLeft: 20,
            paddingRight: 20,
            justifyContent: 'center',
            alignItems: 'center',
            height: '85%',
            overflow: 'auto',
        }

        let deviceInfoContainer = {
            //padding: 20,
            maxWidth: '80%',
            textAlign: 'left',
        }

        let deviceContainer = {
            backgroundColor: '#f9f9f9',
            borderRadius: 10,
            maxWidth: '100%',
            width: 'auto',
            alignItems: 'center',
            justifyContent: 'left',
            position: 'relative',
            display: 'flex',
            marginTop: 10,
            marginBottom: 10,
            padding: 10,
        }

        let cctvIcon_style = {
            width: 52,
            height: 52,
        }

        let iconContainer = {
            padding: 10,
            maxWidth: '20%',
        }

        let deviceName = {
            fontSize: 16,
            color: 'black',
            fontWeight: 'bold',
            padding: 0,
            margin: 5,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        }

        let serialNo = {
            fontSize: 14,
            color: '#BBBBBB',
            margin: 5,
            padding: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        }

        return (
            <div style={{ backgroundColor: '#f7f7f7' }}>

                <div style={main_content_style} className='slideInDown'>

                    {/* Header */}
                    <Top_Bar
                        width={this.props.width}
                        title={this.props.receiver.getString('devices')}
                        left_button_type={'back'}
                        handleLeftButton={this.handlePrevious}
                        right_button_type={'add'}
                        handleRightButton={this.handleAddDevice}
                    />

                    {/* Number of screens */}
                    <div id='dropdown' style={{ marginLeft: 20, display: 'inline-block' }}>
                        <span style={{ color: 'black', display: 'inline-block' }}>{this.props.receiver.getString("ipcam_numberscreens")}</span>

                        {/* Tommy - 29/03/2021 */}
                        <Select
                            style={{ display: 'initial', marginLeft: 20 }}
                            select_style={{ width: 'auto' }}
                            options={this.state.drop_down_list}
                            value={this.state.num_screen}
                            onSelect={this.handleChangeNumScreen}
                        />
                    </div>

                    {/* <div style={{ paddingTop: 20, paddingBottom: 20, alignItems: 'center', zIndex: 999 }}>
                        <div style={{ width: 100, display: 'inline-block', textAlign: 'left' }} onClick={this.handlePrevious}>
                            <img src={back} style={{ width: 20, height: 20, marginLeft: 30 }} />
                        </div>
                        <div style={{ width: this.props.width-200, maxWidth: this.props.width-200, textAlign: 'center', display: 'inline-block' }}>
                            <span style={{ fontSize: 'medium', color: 'black', fontWeight: 'bold' }}>{this.props.receiver.getString('devices')}</span>
                        </div>
                        <div style={{ width: 50, display: 'inline-block', textAlign: 'right', height:'20px' }} onClick={this.handleChangeNumScreen}>
                            <p style={{float:'left', color:"black", marginBottom:'0px', marginTop:'3px'}}>{this.state.num_screen}</p>
                            <img src={monitor_white} style={{ width: 20, height: 20, marginLeft:5, float:'left'}} />
                        </div>
                        <div style={{ width: 50, display: 'inline-block', textAlign: 'right' }} onClick={this.handleAddDevice}>
                            <img src={plus} style={{ width: 20, height: 20, marginRight: 30 }} />
                        </div>
                    </div> */}

                    {/* Display list of devices */}
                    <div style={container_style}>
                        <div id="deviceContainer">
                            {this.devices.map((device_info, index) => {
                                return (
                                    <div style={deviceContainer} id={index} onClick={() => { this.accessCameraDetailsView(index) }}>
                                        <div style={iconContainer}>{
                                            (device_info.deviceType == 5 || device_info.deviceType == 10) ? <img style={cctvIcon_style} src={nvr} /> :
                                                <img style={cctvIcon_style} src={ipcam} />
                                        }
                                        </div>
                                        <div style={deviceInfoContainer}>
                                            <p style={deviceName}>{device_info.deviceName}</p>
                                            <p style={serialNo}>{device_info.serialNo}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}